import { useQuery } from '@tanstack/react-query';
import type { ElasticListVehicle } from '@//app/api/search/vehicles';
import { useApiBaseUrl } from '@//providers/MarketSettingsProvider';
import { httpClientGetJson } from '../../httpClient';

const useRelatedVehicles = (id?: string) => {
  const apiBaseUrl = useApiBaseUrl();
  const query = useQuery<ElasticListVehicle[]>({
    queryKey: ['related-vehicles', id],
    queryFn: async () => {
      const url = `${apiBaseUrl}/api/search/vehicles/related/${id}`;
      return await httpClientGetJson<ElasticListVehicle[]>(url);
    },
    placeholderData: (t) => t,
    enabled: !!id,
  });

  return query;
};

export default useRelatedVehicles;
